import React, { useState } from "react"
import EventData from "../data/Event-Data"
import { motion } from "framer-motion"

const Event = () => {
   const data = EventData
   const [expandedIndex, setExpandedIndex] = useState(null)

   const handleCardClick = (index) => {
      if (expandedIndex === index) {
         setExpandedIndex(null)
      } else {
         setExpandedIndex(index)
      }
   }

   return (
      <div id='Event'>
         <div className='inner flexCenter'>
            <h1>Event List</h1>
            <div className='CardBox'>
               {data.map((item, index) => {
                  // ↑ 맵 함수
                  const isExpanded = expandedIndex === index
                  // ↑ 개별 항목 선택되게끔
                  return (
                     <motion.div
                        key={index}
                        className={`card ${isExpanded ? "expanded" : ""}`}
                        onClick={() => handleCardClick(index)}
                        animate={{
                           scale: isExpanded ? 1 : 1,
                           width: isExpanded ? "50%" : "23.5%",
                        }}
                        transition={{ duration: 0.3 }}
                     >
                        <img src={item.imgUrl} alt='이벤트 이미지' /> <br />
                        <div
                           style={{
                              display: "flex",
                              justifyContent: "space-between",
                           }}
                        >
                           <span style={{ color: "red" }}>{item.progress}</span>{" "}
                           <span>{item.spot}</span>
                        </div>
                        <h3>{item.name}</h3>
                        <span>{item.schedule}</span>
                        {isExpanded && (
                           <div className='card-details'>
                              <p>{item.description1}</p>
                              <p>{item.description2}</p>
                              <p className='mb60'>{item.description3}</p>
                              <span>{item.subData}</span>
                           </div>
                        )}
                     </motion.div>
                  )
               })}
            </div>
         </div>
      </div>
   )
}

export default Event
